import { render, staticRenderFns } from "./SmallError.vue?vue&type=template&id=7f40de56&scoped=true&"
import script from "./SmallError.vue?vue&type=script&lang=js&"
export * from "./SmallError.vue?vue&type=script&lang=js&"
import style0 from "./SmallError.vue?vue&type=style&index=0&id=7f40de56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40de56",
  null
  
)

export default component.exports